import React from 'react';
import PropTypes from 'prop-types';

import { getEvents } from './calendar-api';
import EventCard from './EventCard';
import Paginate from './Paginate';
import EventDetails from './EventDetails';
import './EventsContainer.css';

class EventsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 1, events: null, modal: null, showEnded: this.props.showEnded };
    this.handlePaginate = this.handlePaginate.bind(this);
    this.toggleModal = this.toggleModal.bind(this);

    this.format = new Intl.DateTimeFormat(undefined,
      { weekday: 'long', month: 'long', day: 'numeric' }
    ).format;
  }

  componentDidMount() {
    this.loadEvents();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.startDate !== this.props.startDate) {
      this.loadEvents();
    }
  }

  loadEvents() {
    const dateTheme = this.props.startDate.toLocaleDateString('en-US', {month: 'short', day: '2-digit'}).replace(' ', '-').toLowerCase();
    if (document.body.classList.item(2)) {
      document.body.classList.replace(document.body.classList.item(2), dateTheme);
    } else {
      document.body.classList.add(dateTheme);
    }

    const start = this.props.startDate;
    getEvents(
      this.props.startDate, 
      this.props.endDate 
      || new Date(start.getFullYear(), start.getMonth(), start.getDate() + 2),
      this.props.noBackDate
    )
    .then(events => this.setState({ events: events.sort((one, two) => one.start > two.start), page: 1 }, () => this.props.onEvents(events)))
    .catch(console.error);
  }

  handlePaginate(direction) {
    const last = this.state.page;
    const page = direction === 'down'  ? last + 1 : last - 1;
    this.setState({ page });
  }

  toggleModal(id) {
    this.setState({ modal: id })
  }

  render() {
    if (this.state.events) {
      const now = new Date();

      let events;
      // week/month view
      if (this.props.showEnded) {

        const ended = this.state.events.filter(event => event.end < now);
        const notEnded = this.state.events.filter(event => event.end > now);
        // append ended events to end of list
        events = notEnded.concat(ended);

      } else if (this.state.showEnded) {
        events = this.state.events.sort((one, two) => {
          if (one.end < now) {
            return -1;
          } else {
            return one.start - two.start
          }
        });
      } else {
        events = this.state.events.filter(event => event.end > now);
      }

      if (!events.length) {
        return(
          <div className="no-events">
            <p>There are no events currently planned for this day.</p>
          </div>
        );
      }

      const totalPages = Math.ceil(events.length / this.props.perPage);
      const start = (this.state.page - 1) * this.props.perPage;

      return(
        <div className="events-parent">
          <div className="events">
            { this.state.modal && <EventDetails eventID={this.state.modal} toggleModal={this.toggleModal} />}
              <header>
              {this.props.title && <h2>{this.props.title}</h2>}
              <div className="header-and-options">
              
            { this.props.mode === '1' &&
              <p className="page-indicator">{`Page ${this.state.page} of ${totalPages}`}</p> 
            }
            {this.props.showOptions && 
              <div className="show-ended-events">
                <p>Show ended events</p>
                <div 
                  className={`checkbox-circle ${this.state.showEnded ? 'checked' : ''}`}
                  onClick={() => this.setState({ showEnded: !this.state.showEnded })}
                  ></div>
                </div>}
            </div>
            </header>
            <div className="container">
              <div className="events-grid">
              {
                this.props.mode === '1'
                ?
                events
                  .slice(start, start + this.props.perPage)
                  .map(details => <EventCard mode={this.props.mode} key={details.eventID} details={details} showDayOnTimestamp={this.props.showDayOnTimestamp} toggleModal={this.toggleModal} />)
                :
                events.map(details => <EventCard mode={this.props.mode} key={details.eventID} details={details} showDayOnTimestamp={this.props.showDayOnTimestamp} toggleModal={this.toggleModal} />)
              }
              </div>
              <div className="pagination">
                {this.state.page !== 1 
                  && <Paginate up handlePaginate={this.handlePaginate} />
                }
                {this.state.page < totalPages 
                  && <Paginate down handlePaginate={this.handlePaginate} />
                }
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

EventsContainer.propTypes = {
  title: PropTypes.string,
  startDate: PropTypes.instanceOf(Date).isRequired,
  perPage: PropTypes.number,
  showEnded: PropTypes.bool,
  showOptions: PropTypes.bool,
  showDayOnTimestamp: PropTypes.bool,
  onEvents: PropTypes.func,
};

EventsContainer.defaultProps = {
  perPage: 9,
  showEnded: false,
  showOptions: false,
  showDayOnTimestamp: false,
  onEvents: () => null
};

export default EventsContainer;